import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('workflow_estrutural', 'execucao/ajuste_verba');

const workflowAjusteVerbaActions = {
  aprovador: { method: 'GET', url: `${basePath}/{idAjuste}/passos/aprovador` },
  aprovar: { method: 'PUT', url: `${basePath}/{idAjuste}/passos/aprovar` },
  cancelar: { method: 'PUT', url: `${basePath}/{idAjuste}/cancelar` },
  gravar: { method: 'POST', url: `${basePath}/{idAjuste}` },
  pendentes: { method: 'GET', url: `${basePath}/busca-fluxo-pendente` },
  reprovar: { method: 'PUT', url: `${basePath}/{idAjuste}/passos/reprovar` },
  status: { method: 'GET', url: `${basePath}/{idAjuste}/status` },
  statusPasso: { method: 'GET', url: `${basePath}/{idAjuste}/passos/status` },
};

export default resource => resource(`${basePath}`, {}, workflowAjusteVerbaActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/workflow-ajuste-verba.js